export enum UserApiKeyStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED'
}

export const QUOTA_PERIODS: { value: string; translationKey: string }[] = [
  { value: 'DAY', translationKey: 'IOT_DICTIONARY.PER_DAY' },
  { value: 'WEEK', translationKey: 'IOT_DICTIONARY.PER_WEEK' },
  { value: 'MONTH', translationKey: 'IOT_DICTIONARY.PER_MONTH' }
];

export const EXPIRATION_DATES: { value: number; translationKey: string }[] = [
  { value: 15, translationKey: 'IOT_DICTIONARY.FIFTEEN_DAYS' },
  { value: 180, translationKey: 'IOT_DICTIONARY.SIX_MONTHS' },
  { value: 365, translationKey: 'IOT_DICTIONARY.ONE_YEAR' }
];

export interface UsagePlan {
  id: string;
  quota: {
    limit: number;
    offset: number;
    period: string;
  };
  throttle: {
    burstLimit: number;
    rateLimit: number;
  };
}

export interface UserApiKey {
  id: string;
  name: string;
  description: string;
  status: UserApiKeyStatus;
  issuedAt: string;
  expiresAt: string;
  isExpired: boolean;
  consumerKey: string;
  userId: string;
  businessProfile: {
    id: string;
    name: string;
  };
  usagePlan: UsagePlan;
}
